import {resolveCSSVariable} from "./cssVariableResolver";

// Fallback colors for when CSS variables aren't available yet
const FALLBACK_COLORS = {
    green: "#0EAA0B",
    yellow: "#FEED3D",
    orange: "#FF4C10",
    red: "#C82810",
    purple: "#6726D7",
    blue: "#3090E8",
};

// Lazy initialization with getter functions
export const COLORS = {
    get green() {
        return resolveCSSVariable("--scorza-green") || FALLBACK_COLORS.green;
    },
    get yellow() {
        return resolveCSSVariable("--scorza-yellow") || FALLBACK_COLORS.yellow;
    },
    get orange() {
        return resolveCSSVariable("--scorza-orange") || FALLBACK_COLORS.orange;
    },
    get red() {
        return resolveCSSVariable("--scorza-red") || FALLBACK_COLORS.red;
    },
    get purple() {
        return resolveCSSVariable("--scorza-purple") || FALLBACK_COLORS.purple;
    },
    get blue() {
        return resolveCSSVariable("--scorza-blue") || FALLBACK_COLORS.blue;
    },
};

// Alternative: Function-based approach for explicit control
export function getColors() {
    return {
        green: resolveCSSVariable("--scorza-green") || FALLBACK_COLORS.green,
        yellow: resolveCSSVariable("--scorza-yellow") || FALLBACK_COLORS.yellow,
        orange: resolveCSSVariable("--scorza-orange") || FALLBACK_COLORS.orange,
        red: resolveCSSVariable("--scorza-red") || FALLBACK_COLORS.red,
        purple: resolveCSSVariable("--scorza-purple") || FALLBACK_COLORS.purple,
        blue: resolveCSSVariable("--scorza-blue") || FALLBACK_COLORS.blue,
    };
}

// For React components: Hook to get colors with automatic updates
export function useColors() {
        const React = (window as any).React;
        const [colors, setColors] = React.useState(FALLBACK_COLORS);

        React.useEffect(() => {
            // Update colors once DOM is ready
            setColors(getColors());
        }, []);

        return colors;
}
